<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>note_add</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Alta de Movimiento Puntual de Caja</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-autocomplete
                :items="listConceptos"
                v-model="model.conceptoId"
                item-text="descripcionCompleta"
                item-value="id"
                label="Movimiento a Generar"
                :hint="hintConceptoSeleccionado"
                persistent-hint
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row
            v-if="
              listConceptos.find((c) => c.id == this.model.conceptoId) &&
                listConceptos.find((c) => c.id == this.model.conceptoId)
                  .conceptoMovimientoAOtraCajaId > 0
            "
          >
            <v-col cols="6">
              <v-autocomplete
                :items="listCajas"
                v-model="model.cajaDestinoId"
                placeholder="Seleccione la Caja Destino"
                item-text="descripcion"
                item-value="id"
                label="Caja Destino"
                loading="loadingCajas"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="3"
              v-if="
                $store.state.parametrosGenerales.cajaPermiteMultiMoneda &&
                  cajaMultiMoneda
              "
            >
              <v-autocomplete
                :items="listMonedas"
                v-model="model.monedaId"
                placeholder="Moneda del Movimiento"
                item-text="simbolo"
                item-value="id"
                label="Moneda"
                loading="loadingMonedas"
              ></v-autocomplete>
            </v-col>

            <v-col>
              <v-text-field
                v-model="model.importe"
                label="Importe"
                type="number"
                prefix="$"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row
            v-if="
              $store.state.parametrosGenerales.cajaPermiteMultiMoneda &&
                cajaMultiMoneda &&
                listMonedas.length > 0 &&
                !listMonedas.find((m) => m.id == model.monedaId).predeterminada
            "
          >
            <v-col
              v-if="
                listMonedas.find((m) => m.id == model.monedaId).cotizacion > 0
              "
            >
              <v-chip color="info">
                {{
                  listMonedas.find((m) => m.id == model.monedaId)
                    .cotizacionDescripcion
                }}
              </v-chip>
            </v-col>
            <v-col v-else>
              <v-chip color="error">
                {{
                  listMonedas.find((m) => m.id == model.monedaId)
                    .cotizacionDescripcion
                }}
              </v-chip>
            </v-col>

            <v-col
              v-if="
                !listMonedas.find((m) => m.id == model.monedaId).predeterminada
              "
            >
              <v-chip color="green" dark>
                Equivale a: {{ importeMonedaLocal | currency }}
              </v-chip>
            </v-col>
          </v-row>

          <v-row>
            <v-textarea
              v-model="model.comentarios"
              class="mx-2"
              label="Comentarios Adicionales"
              prepend-icon="comment"
              clearable
              auto-grow
            ></v-textarea>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="hide(false)"
          :disabled="saving"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="save" :disabled="saving"
          >Confirmar Alta</v-btn
        >
      </v-card-actions>
    </v-card>

    <app-loading :loading="saving"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ model }}
      <p></p>
      Monedas: {{ listMonedas }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { Decimal } from 'decimal.js';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    model: {
      importe: 0,
      comentarios: '',
      cajaId: 0,
      conceptoId: 0,
      monedaId: 1,
      cotizacion: 1,
    },
    saving: false,
    loadingCajas: false,
    loadingMonedas: false,
    listConceptos: [],
    listCajas: [],
    listMonedas: [],
  }),
  props: {
    cajaId: { type: Number },
    cajaMultiMoneda: { type: Boolean },
    fechaCaja: { type: String },
    accionCompleta: { type: Function },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  async created() {
    await this.loadConceptosMovimientos();
    await this.loadCajas();
    if (this.cajaMultiMoneda) await this.loadMonedas();

    this.model.cajaId = this.cajaId;
    this.model.fecha = this.fechaCaja;
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    hintConceptoSeleccionado: function() {
      if (this.model.conceptoMovimientoId > 0) {
        if (
          this.listConceptos.find(
            (c) => c.id == this.model.conceptoMovimientoId
          ).conceptoMovimientoAOtraCajaDescripcion
        )
          return (
            'Genera: ' +
            this.listConceptos.find(
              (c) => c.id == this.model.conceptoMovimientoId
            ).conceptoMovimientoAOtraCajaDescripcion
          );
      }

      return '';
    },
    importeMonedaLocal: function() {
      if (this.listMonedas.length <= 1) return this.model.importe;
      if (this.model.importe == '') return 0;

      var moneda = this.listMonedas.find((m) => m.id == this.model.monedaId);
      if (!moneda.predeterminada)
        return new Decimal(this.model.importe).times(moneda.cotizacion);

      return this.model.importe;
    },
  },
  watch: {
    visible: function() {
      if (this.visible) {
      }
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'setReporteActivo',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async save() {
      if (this.cajaMultiMoneda)
        this.model.cotizacion = this.listMonedas.find(
          (m) => m.id == this.model.monedaId
        ).cotizacion;

      if (!this.validarDatos()) return;

      this.saving = true;

      try {
        await http.post(
          'cajas/altamovimiento',
          JSON.stringify({ parametros: this.model })
        );

        this.alertSuccess('El movimiento ha sido generado.');
        this.emitAccionCompleta();

        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;

      if (this.model.conceptoId == 513) var self = this;

      try {
        self.loading = true;

        let params = [];

        params.push({
          Concepto: this.model.comentarios,
          Importe: this.model.importe,
        });

        this.setReporteActivo({
          reporte: 'Alta De Movimientos Puntual De Caja.trdp',
          params: params,
        });
        window.open('/report-viewer');
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    validarDatos() {
      if (!this.model.cajaId) {
        this.alertWarning('No se estableció la Caja.');
        return false;
      }

      //tipo gestión telefónica
      if (
        this.listConceptos.find((c) => c.id == this.model.conceptoId) &&
        this.listConceptos.find((c) => c.id == this.model.conceptoId)
          .conceptoMovimientoAOtraCajaId > 0
      ) {
        if (!(this.model.cajaDestinoId > 0)) {
          this.alertWarning('Debe elegir la Caja Destino del Movimiento.');
          return false;
        }
      }

      if (!(this.model.importe > 0)) {
        this.alertWarning('Debe ingresar el Importe del Movimiento.');
        return false;
      }
      return true;
    },
    async loadCajas() {
      this.listCajas = [];
      this.loadingCajas = true;
      try {
        var result = await http.get('cajas');
        this.listCajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingCajas = false;
    },
    async loadConceptosMovimientos() {
      this.loading = true;
      try {
        await http
          .get(
            'cajas/listconceptosmovimientos?incluirDeSistema=false&limit=100&page=1'
          )
          .then((res) => {
            this.listConceptos = res.list;
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMonedas() {
      this.listMonedas = [];
      this.loadingMonedas = true;
      try {
        var result = await http.get('monedas');
        this.listMonedas = result.list;
        this.model.monedaId = this.listMonedas.find(
          (m) => m.predeterminada == true
        ).id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingMonedas = false;
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    emitAccionCompleta() {
      if (this.accionCompleta) this.accionCompleta();

      this.$emit('accion-completa');
    },
  },
};
</script>
